import Svg from 'components/utilities/svg'

const ShieldIcon = ({ ...props }) => (
  <Svg viewBox="0 -960 960 960" {...props}>
    <title>Shield Icon</title>
    <path d="M480-80q-139-35-229.5-159.5T160-516v-244l320-120 320 120v244q0 152-90.5 276.5T480-80Zm-80-240h160q17 0 28.5-11.5T600-360v-120q0-17-11.5-28.5T560-520v-40q0-33-23.5-56.5T480-640q-33 0-56.5 23.5T400-560v40q-17 0-28.5 11.5T360-480v120q0 17 11.5 28.5T400-320Zm40-200v-40q0-17 11.5-28.5T480-600q17 0 28.5 11.5T520-560v40h-80Z" />
  </Svg>
)

ShieldIcon.displayName = 'Shield'

export default ShieldIcon
